import styled from 'styled-components/macro'

import { Button, Text, TextField } from '@loadsmart/loadsmart-ui'
import { getToken } from '@loadsmart/loadsmart-ui/dist/theming'

export const RejectReasonSeparator = styled.div`
  margin-top: ${getToken('space-l')};
`
export const StyledButton = styled(Button)`
  width: 100%;
`

export const StyledTextField = styled(TextField)`
  width: 100%;
`
export const TextLeftAligned = styled(Text)`
  text-align: left;
`
